var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutdent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12.1665H14.5M20.5 8.6665H8.5M20.5 15.8332H14.5M20.5 19.3332H8.5",
    stroke: "#686E7A",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2778 15.9999C12.2778 16.3432 12.2778 16.5148 12.207 16.6054C12.1453 16.6841 12.0515 16.7311 11.9514 16.7331C11.8365 16.7355 11.6992 16.6325 11.4245 16.4265L8.84672 14.4932C8.65373 14.3485 8.55723 14.2761 8.52272 14.1874C8.4925 14.1096 8.4925 14.0234 8.52272 13.9457C8.55723 13.857 8.65373 13.7846 8.84672 13.6399L11.4245 11.7065C11.6992 11.5005 11.8365 11.3976 11.9514 11.3999C12.0515 11.402 12.1453 11.4489 12.207 11.5277C12.2778 11.6182 12.2778 11.7899 12.2778 12.1332V15.9999Z",
    stroke: "#686E7A",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdent);
export default __webpack_public_path__ + "static/media/outdent.100a0f356c81b0cd965719e853671031.svg";
export { ForwardRef as ReactComponent };